import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { DiscountsAutocomplete, Form } from "@shared/components";

export const CodeListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("limited_code_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <DiscountsAutocomplete
          name="discount"
          label={translate("limited_code_admin.fields.discount")}
          required
        />
      </Grid>
    </Grid>
  );
});
